import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { today } from 'src/app/functions';

@Component({
  selector: 'app-section-message-date',
  templateUrl: './section-message-date.component.html',
  styleUrls: ['./section-message-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionMessageDateComponent implements OnInit, OnDestroy {
  @Input() size: 'md' | 'lg' = 'md';

  @Input() isGift?: boolean;

  public shippingDate = new BehaviorSubject<string>('');

  public lastDate = new BehaviorSubject<string>('');

  private _intervalId?: number;

  constructor() { }

  ngOnInit(): void {
    this._update();

    // async each minute update
    this._intervalId = window.setInterval(() => {
      this._update();
    }, 60000);
  }

  ngOnDestroy(): void {
    window.clearInterval(this._intervalId);
  }

  private _update(): void {
    this.shippingDate.next(today.getExpectedShippingDate('YYYY/MM/DD'));
    this.lastDate.next(today.getEndOfCycleDate('YYYY/MM/DD'));
  }
}
